import { Check } from "lucide-react";

const STEPS = [
  { key: "define", label: "Define" },
  { key: "ideas", label: "Ideas" },
  { key: "build", label: "Build" },
  { key: "done", label: "Done" },
];

const STEP_MAP: Record<string, number> = {
  entry: 0,
  input: 0,
  products: 1,
  ideas: 1,
  format: 2,
  structure: 2,
  building: 2,
  pricing: 3,
  complete: 3,
};

interface MonetizationStepperProps {
  currentStep: string;
}

export function MonetizationStepper({ currentStep }: MonetizationStepperProps) {
  const activeIndex = STEP_MAP[currentStep] ?? 0;

  return (
    <div className="flex items-center gap-1 mb-6 md:mb-8">
      {STEPS.map((step, i) => {
        const isComplete = i < activeIndex || (currentStep === "complete" && i <= activeIndex);
        const isActive = i === activeIndex && currentStep !== "complete";

        return (
          <div key={step.key} className="flex items-center gap-1">
            <div className="flex items-center gap-1.5">
              <div
                className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-semibold shrink-0 transition-colors ${
                  isComplete
                    ? "bg-green-500 text-background"
                    : isActive
                    ? "bg-green-500/20 text-green-400 ring-2 ring-green-500/40"
                    : "bg-muted text-muted-foreground"
                }`}
              >
                {isComplete ? <Check className="w-3.5 h-3.5" /> : i + 1}
              </div>
              <span
                className={`text-xs font-medium hidden sm:inline ${
                  isComplete || isActive ? "text-foreground" : "text-muted-foreground"
                }`}
              >
                {step.label}
              </span>
            </div>
            {i < STEPS.length - 1 && (
              <div
                className={`w-6 md:w-10 h-0.5 rounded-full mx-0.5 ${
                  i < activeIndex || (currentStep === "complete" && i < STEPS.length - 1)
                    ? "bg-green-500"
                    : "bg-muted"
                }`}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
